import React from 'react';
import { DraggableChip } from './chip-draggable/chip-draggable';
import { ChipInput } from './chip-input';
import { ChipSearch } from './chip-search';
import { ChipSelect } from './chip-select';
import { ChipTrigger } from './chip-trigger';
export const Chip = () => React.createElement(React.Fragment, null);
Chip.Trigger = ChipTrigger;
Chip.Select = ChipSelect;
Chip.Input = ChipInput;
Chip.Search = ChipSearch;
Chip.Draggable = DraggableChip;
//# sourceMappingURL=chip.js.map